import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { Field, Form, Formik } from 'formik';

import { actions as reduxActions } from './reducers';
import styles from './styles';
import FrontendSettings from './components/FrontendSettings';
import ActionsButtons from './components/ActionsButtons';
import OtherSettings from './components/OtherSettings';
import { updateOnSubmit } from './actions/updateSettings';
import { fetchSettings } from './actions/getSettings';
import { withRouter } from 'react-router-dom';
import getValueFromLocation from '../../utils/getValueFromLocation';
import changeObjectValues from '../../utils/changeObjectValues';
import MsSettings from './components/MsSettings';
import { isUndefined } from '../../utils/isDefined';
import Setup from './components/Setup';
import { translate } from '../../i18n/I18nProvider';

export function AppSettings({
  classes,
  settings,
  updateOnSubmit,
  resetSettings,
  fetchSettings,
  location,
  partnerId,
  name,
  userPartnerId
}) {
  const isNewPartner = getValueFromLocation(location, 'isNewPartner');

  useEffect(() => {
    let id = getValueFromLocation(location, 'id');

    if (isNewPartner) {
      id = null;
    } else if (isUndefined(id)) {
      id = userPartnerId;
    }

    fetchSettings(id);
    return resetSettings;
    // eslint-disable-next-line
  }, [isNewPartner, location]);

  return (
    <Formik
      initialValues={{ ...changeObjectValues(settings, null, ''), name }}
      onSubmit={values =>
        updateOnSubmit({ settings: values, partnerId, isNewPartner })
      }
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit, dirty }) => {
        return (
          <Form className={classes.content} onSubmit={handleSubmit}>
            <div className={classes.label}>
              {isNewPartner
                ? translate('BUTTON.NEW_PARTNER')
                : translate('EDIT_PARTNER')}
            </div>
            <Field component={Setup} isNewPartner={isNewPartner} />
            <Field component={OtherSettings} />
            <Field component={FrontendSettings} />
            <Field component={MsSettings} />
            <footer className={classes.footer}>
              <ActionsButtons handleSubmit={handleSubmit} dirty={dirty} />
            </footer>
          </Form>
        );
      }}
    </Formik>
  );
}

const mapStatesToProps = ({ appSettings, auth }) => {
  return {
    ...appSettings,
    userPartnerId: auth.user.partner_id
  };
};

const mapDispatchToProps = {
  ...reduxActions,
  fetchSettings,
  updateOnSubmit
};

export default flowRight(
  withRouter,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(AppSettings);
